<div class="input-group input-group-sm">
  @if (prefix) {
    <div class="input-group-prepend"><span class="input-group-text text-muted">{{prefix}}</span></div>
  }
  <div class="input-group-prepend"><span class="input-group-text material-icons">attach_money</span></div>
  <input class="form-control form-control-sm text-right" type="text" [placeholder]="placeHolder" autocomplete="off" [id]="id" [formControl]="control" (keydown)="keydown($event)" (blur)="blur($event)" (focus)="focus($event)" />
  @if (suffix) {
    <div class="input-group-append"><span class="input-group-text text-muted">{{suffix}}</span></div>
  }
</div>